module.exports = __webpack_public_path__ + "static/media/as_mask2.b1215eba.png";